import { useForm as useFormHook } from "hooks";
import { when } from "util/support";
import type { UboIdentity as IUboIdentity, OnboardingIdentityVerification } from 'features/onboarding/types';
import useValidationSchema from "./useValidationSchema";
import type {
    IdentityVerification,
    OnboardingIdentityVerificationForm
} from "./types";
import { Identity } from "./entities";

export const getInitialValues = ({
    uboIdentities = [],
    ...restInitialValues
}: OnboardingIdentityVerification): IdentityVerification => ({
    uboIdentities: when(
        uboIdentities.length,
        uboIdentities,
        [{}]
    )
        .map((uboIdentity: IUboIdentity) => new Identity(uboIdentity)),
    ...restInitialValues
});

export const useForm = (onboardingIdentityVerification: OnboardingIdentityVerificationForm) =>
    useFormHook({
        isInitialValid: false,
        ...onboardingIdentityVerification,
        validateOnMount: true,
        validationSchema: useValidationSchema()
    });
